var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "account_box" },
    [
      _c("div", { staticClass: "title_box" }, [_vm._v("超级补贴商品管理")]),
      _vm._v(" "),
      _c("div", { staticClass: "content_box mt20" }, [
        _c("div", { staticClass: "stat_row" }, [
          _c("div", { staticClass: "stat_item" }, [
            _c("div", { staticClass: "stat_label" }, [_vm._v("累计补贴金额")]),
            _vm._v(" "),
            _c("div", { staticClass: "stat_value" }, [
              _vm._v("\n          " + _vm._s(_vm.subsidyAmtTotalText)),
              _c("span", { staticClass: "stat_unit" }, [_vm._v("元")]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "stat_item" }, [
            _c("div", { staticClass: "stat_label" }, [_vm._v("累计出单")]),
            _vm._v(" "),
            _c("div", { staticClass: "stat_value" }, [
              _vm._v("\n          " + _vm._s(_vm.statData.orderCount || 0)),
              _c("span", { staticClass: "stat_unit" }, [_vm._v("笔")]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content_box mt20" }, [
        _c(
          "div",
          { staticClass: "search_criteria" },
          [
            _c("el-input", {
              attrs: { placeholder: "输入商品名称查询", clearable: "" },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.onInquire($event)
                },
              },
              model: {
                value: _vm.queryData.title,
                callback: function ($$v) {
                  _vm.$set(_vm.queryData, "title", $$v)
                },
                expression: "queryData.title",
              },
            }),
            _vm._v(" "),
            _c(
              "el-select",
              {
                attrs: {
                  filterable: "",
                  clearable: "",
                  placeholder: "选择搜索所属活动",
                },
                model: {
                  value: _vm.queryData.activityId,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryData, "activityId", $$v)
                  },
                  expression: "queryData.activityId",
                },
              },
              _vm._l(_vm.activityOption, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.name, value: item.id },
                })
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "el-select",
              {
                attrs: { placeholder: "选择上下架状态", clearable: "" },
                model: {
                  value: _vm.queryData.goodsStatus,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryData, "goodsStatus", $$v)
                  },
                  expression: "queryData.goodsStatus",
                },
              },
              [
                _c("el-option", { attrs: { value: 1, label: "上架" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: 0, label: "下架" } }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-select",
              {
                attrs: { placeholder: "选择销售状态", clearable: "" },
                model: {
                  value: _vm.queryData.saleStatus,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryData, "saleStatus", $$v)
                  },
                  expression: "queryData.saleStatus",
                },
              },
              [
                _c("el-option", { attrs: { value: 0, label: "未开始" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: 1, label: "销售中" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: 2, label: "已结束" } }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "btn_group" },
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.onInquire } },
                  [_vm._v("查询")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "info", plain: "" },
                    on: { click: _vm.onInitialize },
                  },
                  [_vm._v("重置")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "add_btn",
                attrs: { type: "primary", plain: "" },
                on: { click: _vm.onAdd },
              },
              [_vm._v("新增+")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content_box mt20" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "header-cell-style": { textAlign: "center" },
                "cell-style": { textAlign: "center" },
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "所属活动",
                  prop: "activityName",
                  "min-width": "100",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "商品信息", "min-width": "340" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("GoodsInfoCell", { attrs: { row: scope.row } }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "活动内排序",
                  prop: "sortNo",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "补贴金额", "min-width": "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.subsidyAmt))]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "佣金", "min-width": "70" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.commission))]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "累计上架",
                  prop: "stockTotal",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "剩余库存",
                  prop: "stockRemain",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "上下架状态", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-color": "#67c23a",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.onStatusChange(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.goodsStatus,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "goodsStatus", $$v)
                            },
                            expression: "scope.row.goodsStatus",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "下架原因", "min-width": "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.offReason || "-")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "上线时间", "min-width": "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [_vm._v(_vm._s(scope.row.startTime))]),
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(scope.row.endTime))]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "销售状态", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          { class: "sale_status_" + scope.row.saleStatus },
                          [_vm._v(_vm._s(scope.row.saleStatusName))]
                        ),
                        _vm._v(" "),
                        scope.row.saleStatusDesc
                          ? _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: scope.row.saleStatusDesc,
                                  placement: "top",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "el-icon-warning-outline sale_tip",
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "260", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "success", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.onStockAdjust(scope.row)
                              },
                            },
                          },
                          [_vm._v("库存调整")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.onEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "danger", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.onDelete(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "page_box" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.queryData.page,
                  "page-sizes": [10, 20, 30, 40],
                  "page-size": _vm.queryData.size,
                  layout: "total, prev, pager, next, sizes, jumper",
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("GoodsFormDialog", {
        attrs: {
          visible: _vm.dialogVisible,
          "events-type": _vm.eventsType,
          "activity-option": _vm.activityOption,
          detail: _vm.editDetail,
        },
        on: {
          "update:visible": function ($event) {
            _vm.dialogVisible = $event
          },
          saved: _vm.onInquire,
        },
      }),
      _vm._v(" "),
      _c("StockDialog", {
        attrs: { visible: _vm.stockVisible, row: _vm.stockRow },
        on: {
          "update:visible": function ($event) {
            _vm.stockVisible = $event
          },
          saved: _vm.getGoodsList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }